var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('BottomHeader',{attrs:{"is-mobile-view":_vm.checkIsMobileView}}),_c('TopHeader',{attrs:{"is-mobile-view":_vm.checkIsMobileView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }